import { render, staticRenderFns } from "./CapturaDocumentoVerso.vue?vue&type=template&id=8238593a&scoped=true&"
import script from "./CapturaDocumentoVerso.vue?vue&type=script&lang=js&"
export * from "./CapturaDocumentoVerso.vue?vue&type=script&lang=js&"
import style0 from "./CapturaDocumentoVerso.vue?vue&type=style&index=0&id=8238593a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8238593a",
  null
  
)

export default component.exports